export default "__VITE_ASSET__CGwI1kRY__"